import { createFileRoute, Outlet } from "@tanstack/react-router";
import { applyAuthGuard } from "@/routes/-auth-guard";
import EmployeeLayout from "@/app/employee/layout";

export const Route = createFileRoute("/employee/$id")({
  beforeLoad: ({ location }) =>
    applyAuthGuard(location.pathname, new URLSearchParams(location.searchStr)),
  component: () => (
    <EmployeeLayout>
      <Outlet />
    </EmployeeLayout>
  ),
});
